var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{attrs:{"height":"96px"}},[_c('nav',{staticClass:"nav"},[_c('Logo'),_c('Menus')],1)]),_c('el-main',{staticStyle:{"padding":"0","min-height":"calc(100vh - 326px)"}},[_c('Content')],1),_c('el-footer',{staticStyle:{"height":"auto","padding":"0"}},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }